/* eslint-disable max-lines */
import { PaymentCommuneType } from 'context/Payment'


export const CommuneListArr: PaymentCommuneType[] = [
  {
    key: 1,
    code: '1000005-2101',
    commune: 'ANTOFAGASTA',
  },
  {
    key: 2,
    code: '1000005-2102',
    commune: 'MEJILLONES',
  },
  {
    key: 3,
    code: '1000005-2103',
    commune: 'SIERRA GORDA',
  },
  {
    key: 4,
    code: '1000005-2104',
    commune: 'TALTAL',
  },
  {
    key: 5,
    code: '1000005-2105',
    commune: 'ARICA',
  },
  {
    key: 6,
    code: '1000005-2106',
    commune: 'CAMARONES',
  },
  {
    key: 7,
    code: '1000005-2107',
    commune: 'CAUQUENES',
  },
  {
    key: 8,
    code: '1000005-2108',
    commune: 'CHANCO',
  },
  {
    key: 9,
    code: '1000005-2109',
    commune: 'PELLUHUE',
  },
  {
    key: 10,
    code: '1000005-2110',
    commune: 'CHAÑARAL',
  },
  {
    key: 11,
    code: '1000005-2111',
    commune: 'DIEGO DE ALMAGRO',
  },
  {
    key: 12,
    code: '1000005-2112',
    commune: 'CASTRO',
  },
  {
    key: 13,
    code: '1000005-2113',
    commune: 'ANCUD',
  },
  {
    key: 14,
    code: '1000005-2114',
    commune: 'CHONCHI',
  },
  {
    key: 15,
    code: '1000005-2115',
    commune: 'CURACO DE VELEZ',
  },
  {
    key: 16,
    code: '1000005-2116',
    commune: 'DALCAHUE',
  },
  {
    key: 17,
    code: '1000005-2117',
    commune: 'PUQUELDON',
  },
  {
    key: 18,
    code: '1000005-2118',
    commune: 'QUEILEN',
  },
  {
    key: 19,
    code: '1000005-2119',
    commune: 'QUELLON',
  },
  {
    key: 20,
    code: '1000005-2120',
    commune: 'QUEMCHI',
  },
  {
    key: 21,
    code: '1000005-2121',
    commune: 'QUINCHAO',
  },
  {
    key: 22,
    code: '1000005-2122',
    commune: 'CONCEPCION',
  },
  {
    key: 23,
    code: '1000005-2123',
    commune: 'CORONEL',
  },
  {
    key: 24,
    code: '1000005-2124',
    commune: 'CHIGUAYANTE',
  },
  {
    key: 25,
    code: '1000005-2125',
    commune: 'FLORIDA',
  },
  {
    key: 26,
    code: '1000005-2126',
    commune: 'HUALQUI',
  },
  {
    key: 27,
    code: '1000005-2127',
    commune: 'LOTA',
  },
  {
    key: 28,
    code: '1000005-2128',
    commune: 'PENCO',
  },
  {
    key: 29,
    code: '1000005-2129',
    commune: 'SAN PEDRO DE LA PAZ',
  },
  {
    key: 30,
    code: '1000005-2130',
    commune: 'SANTA JUANA',
  },
  {
    key: 31,
    code: '1000005-2131',
    commune: 'TALCAHUANO',
  },
  {
    key: 32,
    code: '1000005-2132',
    commune: 'TOME',
  },
  {
    key: 33,
    code: '1000005-2133',
    commune: 'HUALPEN',
  },
  {
    key: 34,
    code: '1000005-2134',
    commune: 'COPIAPO',
  },
  {
    key: 35,
    code: '1000005-2135',
    commune: 'CALDERA',
  },
  {
    key: 36,
    code: '1000005-2136',
    commune: 'TIERRA AMARILLA',
  },
  {
    key: 37,
    code: '1000005-2137',
    commune: 'COIHAIQUE',
  },
  {
    key: 38,
    code: '1000005-2138',
    commune: 'LAGO VERDE',
  },
  {
    key: 39,
    code: '1000005-2139',
    commune: 'CURICO',
  },
  {
    key: 40,
    code: '1000005-2140',
    commune: 'HUALAÑE',
  },
  {
    key: 41,
    code: '1000005-2141',
    commune: 'LICANTEN',
  },
  {
    key: 42,
    code: '1000039-7304',
    commune: 'MOLINA',
  },
  {
    key: 43,
    code: '1000039-7305',
    commune: 'RAUCO',
  },
  {
    key: 44,
    code: '1000039-7306',
    commune: 'ROMERAL',
  },
  {
    key: 45,
    code: '1000039-7307',
    commune: 'SAGRADA FAMILIA',
  },
  {
    key: 46,
    code: '1000039-7308',
    commune: 'TENO',
  },
  {
    key: 47,
    code: '1000039-7309',
    commune: 'VICHUQUEN',
  },
  {
    key: 48,
    code: '1000055-3301',
    commune: 'VALLENAR',
  },
  {
    key: 49,
    code: '1000055-3302',
    commune: 'ALTO DEL CARMEN',
  },
  {
    key: 50,
    code: '1000055-3303',
    commune: 'FREIRINA',
  },
  {
    key: 51,
    code: '1000055-3304',
    commune: 'HUASCO',
  },
  {
    key: 52,
    code: '1000057-1101',
    commune: 'IQUIQUE',
  },
  {
    key: 53,
    code: '1000057-1107',
    commune: 'ALTO HOSPICIO',
  },
  {
    key: 54,
    code: '1000065-4301',
    commune: 'OVALLE',
  },
  {
    key: 55,
    code: '1000065-4302',
    commune: 'COMBARBALA',
  },
  {
    key: 56,
    code: '1000065-4303',
    commune: 'MONTE PATRIA',
  },
  {
    key: 57,
    code: '1000065-4304',
    commune: 'PUNITAQUI',
  },
  {
    key: 58,
    code: '1000065-4305',
    commune: 'RIO HURTADO',
  },
  {
    key: 59,
    code: '1000066-7401',
    commune: 'LINARES',
  },
  {
    key: 60,
    code: '1000066-7402',
    commune: 'COLBUN',
  },
  {
    key: 61,
    code: '1000066-7403',
    commune: 'LONGAVI',
  },
  {
    key: 62,
    code: '1000066-7404',
    commune: 'PARRAL',
  },
  {
    key: 63,
    code: '1000066-7405',
    commune: 'RETIRO',
  },
  {
    key: 64,
    code: '1000066-7406',
    commune: 'SAN JAVIER',
  },
  {
    key: 65,
    code: '1000066-7407',
    commune: 'VILLA ALEGRE',
  },
  {
    key: 66,
    code: '1000066-7408',
    commune: 'YERBAS BUENAS',
  },
  {
    key: 67,
    code: '1000067-10101',
    commune: 'PUERTO MONTT',
  },
  {
    key: 68,
    code: '1000067-10102',
    commune: 'CALBUCO',
  },
  {
    key: 69,
    code: '1000067-10103',
    commune: 'COCHAMO',
  },
  {
    key: 70,
    code: '1000067-10104',
    commune: 'FRESIA',
  },
  {
    key: 71,
    code: '1000067-10105',
    commune: 'FRUTILLAR',
  },
  {
    key: 72,
    code: '1000067-10106',
    commune: 'LOS MUERMOS',
  },
  {
    key: 73,
    code: '1000067-10107',
    commune: 'LLANQUIHUE',
  },
  {
    key: 74,
    code: '1000067-10108',
    commune: 'MAULLIN',
  },
  {
    key: 75,
    code: '1000067-10109',
    commune: 'PUERTO VARAS',
  },
  {
    key: 76,
    code: '1000070-5301',
    commune: 'LOS ANDES',
  },
  {
    key: 77,
    code: '1000070-5302',
    commune: 'CALLE LARGA',
  },
  {
    key: 78,
    code: '1000070-5303',
    commune: 'RINCONADA',
  },
  {
    key: 79,
    code: '1000070-5304',
    commune: 'SAN ESTEBAN',
  },
  {
    key: 80,
    code: '1000080-13501',
    commune: 'MELIPILLA',
  },
  {
    key: 81,
    code: '1000080-13502',
    commune: 'ALHUE',
  },
  {
    key: 82,
    code: '1000080-13503',
    commune: 'CURACAVI',
  },
  {
    key: 83,
    code: '1000080-13504',
    commune: 'MARIA PINTO',
  },
  {
    key: 84,
    code: '1000080-13505',
    commune: 'SAN PEDRO',
  },
  {
    key: 85,
    code: '1000085-10301',
    commune: 'OSORNO',
  },
  {
    key: 86,
    code: '1000085-10302',
    commune: 'PUERTO OCTAY',
  },
  {
    key: 87,
    code: '1000085-10303',
    commune: 'PURRANQUE',
  },
  {
    key: 88,
    code: '1000085-10304',
    commune: 'PUYEHUE',
  },
  {
    key: 89,
    code: '1000085-10305',
    commune: 'RIO NEGRO',
  },
  {
    key: 90,
    code: '1000085-10306',
    commune: 'SAN JUAN DE LA COSTA',
  },
  {
    key: 91,
    code: '1000085-10307',
    commune: 'SAN PABLO',
  },
  {
    key: 92,
    code: '1000091-10401',
    commune: 'CHAITEN',
  },
  {
    key: 93,
    code: '1000091-10402',
    commune: 'FUTALEUFU',
  },
  {
    key: 94,
    code: '1000091-10403',
    commune: 'HUALAIHUE',
  },
  {
    key: 95,
    code: '1000091-10404',
    commune: 'PALENA',
  },
  {
    key: 96,
    code: '1000128-5601',
    commune: 'SAN ANTONIO',
  },
  {
    key: 97,
    code: '1000128-5602',
    commune: 'ALGARROBO',
  },
  {
    key: 98,
    code: '1000128-5603',
    commune: 'CARTAGENA',
  },
  {
    key: 99,
    code: '1000128-5604',
    commune: 'EL QUISCO',
  },
  {
    key: 100,
    code: '1000128-5605',
    commune: 'EL TABO',
  },
  {
    key: 101,
    code: '1000128-5606',
    commune: 'SANTO DOMINGO',
  },
  {
    key: 102,
    code: '1000129-5701',
    commune: 'SAN FELIPE',
  },
  {
    key: 103,
    code: '1000129-5702',
    commune: 'CATEMU',
  },
  {
    key: 104,
    code: '1000129-5703',
    commune: 'LLAILLAY',
  },
  {
    key: 105,
    code: '1000129-5704',
    commune: 'PANQUEHUE',
  },
  {
    key: 106,
    code: '1000129-5705',
    commune: 'PUTAENDO',
  },
  {
    key: 107,
    code: '1000129-5706',
    commune: 'SANTA MARIA',
  },
  {
    key: 108,
    code: '1000136-13101',
    commune: 'SANTIAGO',
  },
  {
    key: 109,
    code: '1000136-13102',
    commune: 'CERRILLOS',
  },
  {
    key: 110,
    code: '1000136-13103',
    commune: 'CERRO NAVIA',
  },
  {
    key: 111,
    code: '1000136-13104',
    commune: 'CONCHALI',
  },
  {
    key: 112,
    code: '1000136-13105',
    commune: 'EL BOSQUE',
  },
  {
    key: 113,
    code: '1000136-13106',
    commune: 'ESTACION CENTRAL',
  },
  {
    key: 114,
    code: '1000136-13107',
    commune: 'HUECHURABA',
  },
  {
    key: 115,
    code: '1000136-13108',
    commune: 'INDEPENDENCIA',
  },
  {
    key: 116,
    code: '1000136-13109',
    commune: 'LA CISTERNA',
  },
  {
    key: 117,
    code: '1000136-13110',
    commune: 'LA FLORIDA',
  },
  {
    key: 118,
    code: '1000136-13111',
    commune: 'LA GRANJA',
  },
  {
    key: 119,
    code: '1000136-13112',
    commune: 'LA PINTANA',
  },
  {
    key: 120,
    code: '1000136-13113',
    commune: 'LA REINA',
  },
  {
    key: 121,
    code: '1000136-13114',
    commune: 'LAS CONDES',
  },
  {
    key: 122,
    code: '1000136-13115',
    commune: 'LO BARNECHEA',
  },
  {
    key: 123,
    code: '1000136-13116',
    commune: 'LO ESPEJO',
  },
  {
    key: 124,
    code: '1000136-13117',
    commune: 'LO PRADO',
  },
  {
    key: 125,
    code: '1000136-13118',
    commune: 'MACUL',
  },
  {
    key: 126,
    code: '1000136-13119',
    commune: 'MAIPU',
  },
  {
    key: 127,
    code: '1000136-13120',
    commune: 'ÑUÑOA',
  },
  {
    key: 128,
    code: '1000136-13121',
    commune: 'PEDRO AGUIRRE CERDA',
  },
  {
    key: 129,
    code: '1000136-13122',
    commune: 'PEÑALOLEN',
  },
  {
    key: 130,
    code: '1000136-13123',
    commune: 'PROVIDENCIA',
  },
  {
    key: 131,
    code: '1000136-13124',
    commune: 'PUDAHUEL',
  },
  {
    key: 132,
    code: '1000136-13125',
    commune: 'QUILICURA',
  },
  {
    key: 133,
    code: '1000136-13126',
    commune: 'QUINTA NORMAL',
  },
  {
    key: 134,
    code: '1000136-13127',
    commune: 'RECOLETA',
  },
  {
    key: 135,
    code: '1000136-13128',
    commune: 'RENCA',
  },
  {
    key: 136,
    code: '1000136-13129',
    commune: 'SAN JOAQUIN',
  },
  {
    key: 137,
    code: '1000136-13130',
    commune: 'SAN MIGUEL',
  },
  {
    key: 138,
    code: '1000136-13131',
    commune: 'SAN RAMON',
  },
  {
    key: 139,
    code: '1000136-13132',
    commune: 'VITACURA',
  },
  {
    key: 140,
    code: '1000139-13601',
    commune: 'TALAGANTE',
  },
  {
    key: 141,
    code: '1000139-13602',
    commune: 'EL MONTE',
  },
  {
    key: 142,
    code: '1000139-13603',
    commune: 'ISLA DE MAIPO',
  },
  {
    key: 143,
    code: '1000139-13604',
    commune: 'PADRE HURTADO',
  },
  {
    key: 144,
    code: '1000139-13605',
    commune: 'PEÑAFLOR',
  },
  {
    key: 145,
    code: '1000140-7101',
    commune: 'TALCA',
  },
  {
    key: 146,
    code: '1000140-7102',
    commune: 'CONSTITUCION',
  },
  {
    key: 147,
    code: '1000140-7103',
    commune: 'CUREPTO',
  },
  {
    key: 148,
    code: '1000140-7104',
    commune: 'EMPEDRADO',
  },
  {
    key: 149,
    code: '1000140-7105',
    commune: 'MAULE',
  },
  {
    key: 150,
    code: '1000140-7106',
    commune: 'PELARCO',
  },
  {
    key: 151,
    code: '1000140-7107',
    commune: 'PENCAHUE',
  },
  {
    key: 152,
    code: '1000140-7108',
    commune: 'RIO CLARO',
  },
  {
    key: 153,
    code: '1000140-7109',
    commune: 'SAN CLEMENTE',
  },
  {
    key: 154,
    code: '1000140-7110',
    commune: 'SAN RAFAEL',
  },
  {
    key: 155,
    code: '1000148-2301',
    commune: 'TOCOPILLA',
  },
  {
    key: 156,
    code: '1000148-2302',
    commune: 'MARIA ELENA',
  },
  {
    key: 157,
    code: '1000151-14101',
    commune: 'VALDIVIA',
  },
  {
    key: 158,
    code: '1000151-14102',
    commune: 'CORRAL',
  },
  {
    key: 159,
    code: '1000151-14103',
    commune: 'LANCO',
  },
  {
    key: 160,
    code: '1000151-14104',
    commune: 'LOS LAGOS',
  },
  {
    key: 161,
    code: '1000151-14105',
    commune: 'MAFIL',
  },
  {
    key: 162,
    code: '1000151-14106',
    commune: 'MARIQUINA',
  },
  {
    key: 163,
    code: '1000151-14107',
    commune: 'PAILLACO',
  },
  {
    key: 164,
    code: '1000151-14108',
    commune: 'PANGUIPULLI',
  },
  {
    key: 165,
    code: '1000153-5101',
    commune: 'VALPARAISO',
  },
  {
    key: 166,
    code: '1000153-5102',
    commune: 'CASABLANCA',
  },
  {
    key: 167,
    code: '1000153-5103',
    commune: 'CONCON',
  },
  {
    key: 168,
    code: '1000153-5104',
    commune: 'JUAN FERNANDEZ',
  },
  {
    key: 169,
    code: '1000153-5105',
    commune: 'PUCHUNCAVI',
  },
  {
    key: 170,
    code: '1000153-5107',
    commune: 'QUINTERO',
  },
  {
    key: 171,
    code: '1000153-5109',
    commune: 'VIÑA DEL MAR',
  },
  {
    key: 172,
    code: '1001669-15201',
    commune: 'PUTRE',
  },
  {
    key: 173,
    code: '1001669-15202',
    commune: 'GENERAL LAGOS',
  },
  {
    key: 174,
    code: '1001670-1401',
    commune: 'POZO ALMONTE',
  },
  {
    key: 175,
    code: '1001670-1402',
    commune: 'CAMINA',
  },
  {
    key: 176,
    code: '1001670-1403',
    commune: 'COLCHANE',
  },
  {
    key: 177,
    code: '1001670-1404',
    commune: 'HUARA',
  },
  {
    key: 178,
    code: '1001670-1405',
    commune: 'PICA',
  },
  {
    key: 179,
    code: '1001671-2201',
    commune: 'CALAMA',
  },
  {
    key: 180,
    code: '1001671-2202',
    commune: 'OLLAGUE',
  },
  {
    key: 181,
    code: '1001671-2203',
    commune: 'SAN PEDRO DE ATACAMA',
  },
  {
    key: 182,
    code: '1001672-4101',
    commune: 'LA SERENA',
  },
  {
    key: 183,
    code: '1001672-4102',
    commune: 'COQUIMBO',
  },
  {
    key: 184,
    code: '1001672-4103',
    commune: 'ANDACOLLO',
  },
  {
    key: 185,
    code: '1001672-4104',
    commune: 'LA HIGUERA',
  },
  {
    key: 186,
    code: '1001672-4105',
    commune: 'PAIGUANO',
  },
  {
    key: 187,
    code: '1001672-4106',
    commune: 'VICUNA',
  },
  {
    key: 188,
    code: '1001673-4201',
    commune: 'ILLAPEL',
  },
  {
    key: 189,
    code: '1001673-4202',
    commune: 'CANELA',
  },
  {
    key: 190,
    code: '1001673-4203',
    commune: 'LOS VILOS',
  },
  {
    key: 191,
    code: '1001673-4204',
    commune: 'SALAMANCA',
  },
  {
    key: 192,
    code: '1001674-5201',
    commune: 'ISLA DE PASCUA',
  },
  {
    key: 193,
    code: '1001675-5401',
    commune: 'LA LIGUA',
  },
  {
    key: 194,
    code: '1001675-5402',
    commune: 'CABILDO',
  },
  {
    key: 195,
    code: '1001675-5403',
    commune: 'PAPUDO',
  },
  {
    key: 196,
    code: '1001675-5404',
    commune: 'PETORCA',
  },
  {
    key: 197,
    code: '1001675-5405',
    commune: 'ZAPALLAR',
  },
  {
    key: 198,
    code: '1001676-5501',
    commune: 'QUILLOTA',
  },
  {
    key: 199,
    code: '1001676-5502',
    commune: 'CALERA',
  },
  {
    key: 200,
    code: '1001676-5503',
    commune: 'HIJUELAS',
  },
  {
    key: 201,
    code: '1001676-5504',
    commune: 'LA CRUZ',
  },
  {
    key: 202,
    code: '1001676-5506',
    commune: 'NOGALES',
  },
  {
    key: 203,
    code: '1001677-5801',
    commune: 'QUILPUE',
  },
  {
    key: 204,
    code: '1001677-5802',
    commune: 'LIMACHE',
  },
  {
    key: 205,
    code: '1001677-5803',
    commune: 'OLMUE',
  },
  {
    key: 206,
    code: '1001677-5804',
    commune: 'VILLA ALEMANA',
  },
  {
    key: 207,
    code: '1001678-6101',
    commune: 'RANCAGUA',
  },
  {
    key: 208,
    code: '1001678-6102',
    commune: 'CODEGUA',
  },
  {
    key: 209,
    code: '1001678-6103',
    commune: 'COINCO',
  },
  {
    key: 210,
    code: '1001678-6104',
    commune: 'COLTAUCO',
  },
  {
    key: 211,
    code: '1001678-6105',
    commune: 'DONIHUE',
  },
  {
    key: 212,
    code: '1001678-6106',
    commune: 'GRANEROS',
  },
  {
    key: 213,
    code: '1001678-6107',
    commune: 'LAS CABRAS',
  },
  {
    key: 214,
    code: '1001678-6108',
    commune: 'MACHALI',
  },
  {
    key: 215,
    code: '1001678-6109',
    commune: 'MALLOA',
  },
  {
    key: 216,
    code: '1001678-6110',
    commune: 'MOSTAZAL',
  },
  {
    key: 217,
    code: '1001678-6111',
    commune: 'OLIVAR',
  },
  {
    key: 218,
    code: '1001678-6112',
    commune: 'PEUMO',
  },
  {
    key: 219,
    code: '1001678-6113',
    commune: 'PICHIDEGUA',
  },
  {
    key: 220,
    code: '1001678-6114',
    commune: 'QUINTA DE TILCOCO',
  },
  {
    key: 221,
    code: '1001678-6115',
    commune: 'RENGO',
  },
  {
    key: 222,
    code: '1001678-6116',
    commune: 'REQUINOA',
  },
  {
    key: 223,
    code: '1001678-6117',
    commune: 'SAN VICENTE',
  },
  {
    key: 224,
    code: '1001679-6201',
    commune: 'PICHILEMU',
  },
  {
    key: 225,
    code: '1001679-6202',
    commune: 'LA ESTRELLA',
  },
  {
    key: 226,
    code: '1001679-6203',
    commune: 'LITUECHE',
  },
  {
    key: 227,
    code: '1001679-6204',
    commune: 'MARCHIHUE',
  },
  {
    key: 228,
    code: '1001679-6205',
    commune: 'NAVIDAD',
  },
  {
    key: 229,
    code: '1001679-6206',
    commune: 'PAREDONES',
  },
  {
    key: 230,
    code: '1001680-6301',
    commune: 'SAN FERNANDO',
  },
  {
    key: 231,
    code: '1001680-6302',
    commune: 'CHEPICA',
  },
  {
    key: 232,
    code: '1001680-6303',
    commune: 'CHIMBARONGO',
  },
  {
    key: 233,
    code: '1001680-6304',
    commune: 'LOLOL',
  },
  {
    key: 234,
    code: '1001680-6305',
    commune: 'NANCAGUA',
  },
  {
    key: 235,
    code: '1001680-6306',
    commune: 'PALMILLA',
  },
  {
    key: 236,
    code: '1001680-6307',
    commune: 'PERALILLO',
  },
  {
    key: 237,
    code: '1001680-6308',
    commune: 'PLACILLA',
  },
  {
    key: 238,
    code: '1001680-6309',
    commune: 'PUMANQUE',
  },
  {
    key: 239,
    code: '1001680-6310',
    commune: 'SANTA CRUZ',
  },
  {
    key: 240,
    code: '1001682-8201',
    commune: 'LEBU',
  },
  {
    key: 241,
    code: '1001682-8202',
    commune: 'ARAUCO',
  },
  {
    key: 242,
    code: '1001682-8203',
    commune: 'CAÑETE',
  },
  {
    key: 243,
    code: '1001682-8204',
    commune: 'CONTULMO',
  },
  {
    key: 244,
    code: '1001682-8205',
    commune: 'CURANILAHUE',
  },
  {
    key: 245,
    code: '1001682-8206',
    commune: 'LOS ALAMOS',
  },
  {
    key: 246,
    code: '1001682-8207',
    commune: 'TIRUA',
  },
  {
    key: 247,
    code: '1001683-8301',
    commune: 'LOS ANGELES',
  },
  {
    key: 248,
    code: '1001683-8302',
    commune: 'ANTUCO',
  },
  {
    key: 249,
    code: '1001683-8303',
    commune: 'CABRERO',
  },
  {
    key: 250,
    code: '1001683-8304',
    commune: 'LAJA',
  },
  {
    key: 251,
    code: '1001683-8305',
    commune: 'MULCHEN',
  },
  {
    key: 252,
    code: '1001683-8306',
    commune: 'NACIMIENTO',
  },
  {
    key: 253,
    code: '1001683-8307',
    commune: 'NEGRETE',
  },
  {
    key: 254,
    code: '1001683-8308',
    commune: 'QUILACO',
  },
  {
    key: 255,
    code: '1001683-8309',
    commune: 'QUILLECO',
  },
  {
    key: 256,
    code: '1001683-8310',
    commune: 'SAN ROSENDO',
  },
  {
    key: 257,
    code: '1001683-8311',
    commune: 'SANTA BARBARA',
  },
  {
    key: 258,
    code: '1001683-8312',
    commune: 'TUCAPEL',
  },
  {
    key: 259,
    code: '1001683-8313',
    commune: 'YUMBEL',
  },
  {
    key: 260,
    code: '1001683-8314',
    commune: 'ALTO BIO BIO',
  },
  {
    key: 261,
    code: '1001685-9101',
    commune: 'TEMUCO',
  },
  {
    key: 262,
    code: '1001685-9102',
    commune: 'CARAHUE',
  },
  {
    key: 263,
    code: '1001685-9103',
    commune: 'CUNCO',
  },
  {
    key: 264,
    code: '1001685-9104',
    commune: 'CURARREHUE',
  },
  {
    key: 265,
    code: '1001685-9105',
    commune: 'FREIRE',
  },
  {
    key: 266,
    code: '1001685-9106',
    commune: 'GALVARINO',
  },
  {
    key: 267,
    code: '1001685-9107',
    commune: 'GORBEA',
  },
  {
    key: 268,
    code: '1001685-9108',
    commune: 'LAUTARO',
  },
  {
    key: 269,
    code: '1001685-9109',
    commune: 'LONCOCHE',
  },
  {
    key: 270,
    code: '1001685-9110',
    commune: 'MELIPEUCO',
  },
  {
    key: 271,
    code: '1001685-9111',
    commune: 'NUEVA IMPERIAL',
  },
  {
    key: 272,
    code: '1001685-9112',
    commune: 'PADRE LAS CASAS',
  },
  {
    key: 273,
    code: '1001685-9113',
    commune: 'PERQUENCO',
  },
  {
    key: 274,
    code: '1001685-9114',
    commune: 'PITRUFQUEN',
  },
  {
    key: 275,
    code: '1001685-9115',
    commune: 'PUCON',
  },
  {
    key: 276,
    code: '1001685-9116',
    commune: 'SAAVEDRA',
  },
  {
    key: 277,
    code: '1001685-9117',
    commune: 'TEODORO SCHMIDT',
  },
  {
    key: 278,
    code: '1001685-9118',
    commune: 'TOLTEN',
  },
  {
    key: 279,
    code: '1001685-9119',
    commune: 'VILCUN',
  },
  {
    key: 280,
    code: '1001685-9120',
    commune: 'VILLARRICA',
  },
  {
    key: 281,
    code: '1001685-9121',
    commune: 'CHOLCHOL',
  },
  {
    key: 282,
    code: '1001686-9201',
    commune: 'ANGOL',
  },
  {
    key: 283,
    code: '1001686-9202',
    commune: 'COLLIPULLI',
  },
  {
    key: 284,
    code: '1001686-9203',
    commune: 'CURACAUTIN',
  },
  {
    key: 285,
    code: '1001686-9204',
    commune: 'ERCILLA',
  },
  {
    key: 286,
    code: '1001686-9205',
    commune: 'LONQUIMAY',
  },
  {
    key: 287,
    code: '1001686-9206',
    commune: 'LOS SAUCES',
  },
  {
    key: 288,
    code: '1001686-9207',
    commune: 'LUMACO',
  },
  {
    key: 289,
    code: '1001686-9208',
    commune: 'PUREN',
  },
  {
    key: 290,
    code: '1001686-9209',
    commune: 'RENAICO',
  },
  {
    key: 291,
    code: '1001686-9210',
    commune: 'TRAIGUEN',
  },
  {
    key: 292,
    code: '1001686-9211',
    commune: 'VICTORIA',
  },
  {
    key: 293,
    code: '1001687-14201',
    commune: 'LA UNION',
  },
  {
    key: 294,
    code: '1001687-14202',
    commune: 'FUTRONO',
  },
  {
    key: 295,
    code: '1001687-14203',
    commune: 'LAGO RANCO',
  },
  {
    key: 296,
    code: '1001687-14204',
    commune: 'RIO BUENO',
  },
  {
    key: 297,
    code: '1001688-11201',
    commune: 'AISEN',
  },
  {
    key: 298,
    code: '1001688-11202',
    commune: 'CISNES',
  },
  {
    key: 299,
    code: '1001688-11203',
    commune: 'GUAITECAS',
  },
  {
    key: 300,
    code: '1001689-11301',
    commune: 'COCHRANE',
  },
  {
    key: 301,
    code: '1001689-11302',
    commune: 'O\'HIGGINS',
  },
  {
    key: 302,
    code: '1001689-11303',
    commune: 'TORTEL',
  },
  {
    key: 303,
    code: '1001690-11401',
    commune: 'CHILE CHICO',
  },
  {
    key: 304,
    code: '1001690-11402',
    commune: 'RIO IBAÑEZ',
  },
  {
    key: 305,
    code: '1001691-12101',
    commune: 'PUNTA ARENAS',
  },
  {
    key: 306,
    code: '1001691-12102',
    commune: 'LAGUNA BLANCA',
  },
  {
    key: 307,
    code: '1001691-12103',
    commune: 'RIO VERDE',
  },
  {
    key: 308,
    code: '1001691-12104',
    commune: 'SAN GREGORIO',
  },
  {
    key: 309,
    code: '1001692-12201',
    commune: 'CABO DE HORNOS (EX NAVARINO)',
  },
  {
    key: 310,
    code: '1001692-12202',
    commune: 'ANTARTICA',
  },
  {
    key: 311,
    code: '1001693-12301',
    commune: 'PORVENIR',
  },
  {
    key: 312,
    code: '1001693-12302',
    commune: 'PRIMAVERA',
  },
  {
    key: 313,
    code: '1001693-12303',
    commune: 'TIMAUKEL',
  },
  {
    key: 314,
    code: '1001694-12401',
    commune: 'NATALES',
  },
  {
    key: 315,
    code: '1001694-12402',
    commune: 'TORRES DEL PAINE',
  },
  {
    key: 316,
    code: '1001695-13201',
    commune: 'PUENTE ALTO',
  },
  {
    key: 317,
    code: '1001695-13202',
    commune: 'PIRQUE',
  },
  {
    key: 318,
    code: '1001695-13203',
    commune: 'SAN JOSE DE MAIPO',
  },
  {
    key: 319,
    code: '1001696-13301',
    commune: 'COLINA',
  },
  {
    key: 320,
    code: '1001696-13302',
    commune: 'LAMPA',
  },
  {
    key: 321,
    code: '1001696-13303',
    commune: 'TILTIL',
  },
  {
    key: 322,
    code: '1001697-13401',
    commune: 'SAN BERNARDO',
  },
  {
    key: 323,
    code: '1001697-13402',
    commune: 'BUIN',
  },
  {
    key: 324,
    code: '1001697-13403',
    commune: 'CALERA DE TANGO',
  },
  {
    key: 325,
    code: '1001697-13404',
    commune: 'PAINE',
  },
  {
    key: 326,
    code: '5000000-8401',
    commune: 'CHILLAN',
  },
  {
    key: 327,
    code: '5000000-8402',
    commune: 'BULNES',
  },
  {
    key: 328,
    code: '5000000-8406',
    commune: 'CHILLAN VIEJO',
  },
  {
    key: 329,
    code: '5000000-8407',
    commune: 'EL CARMEN',
  },
  {
    key: 330,
    code: '5000000-8410',
    commune: 'PEMUCO',
  },
  {
    key: 331,
    code: '5000000-8411',
    commune: 'PINTO',
  },
  {
    key: 332,
    code: '5000000-8413',
    commune: 'QUILLON',
  },
  {
    key: 333,
    code: '5000000-8418',
    commune: 'SAN IGNACIO',
  },
  {
    key: 334,
    code: '5000000-8421',
    commune: 'YUNGAY',
  },
  {
    key: 335,
    code: '5000001-8405',
    commune: 'COIHUECO',
  },
  {
    key: 336,
    code: '5000001-8409',
    commune: 'ÑIQUEN',
  },
  {
    key: 337,
    code: '5000001-8416',
    commune: 'SAN CARLOS',
  },
  {
    key: 338,
    code: '5000001-8417',
    commune: 'SAN FABIAN',
  },
  {
    key: 339,
    code: '5000001-8419',
    commune: 'SAN NICOLAS',
  },
  {
    key: 340,
    code: '5000002-8403',
    commune: 'COBQUECURA',
  },
  {
    key: 341,
    code: '5000002-8404',
    commune: 'COELEMU',
  },
  {
    key: 342,
    code: '5000002-8408',
    commune: 'NINHUE',
  },
  {
    key: 343,
    code: '5000002-8412',
    commune: 'PORTEZUELO',
  },
  {
    key: 344,
    code: '5000002-8414',
    commune: 'QUIRIHUE',
  },
  {
    key: 345,
    code: '5000002-8415',
    commune: 'RANQUIL',
  },
  {
    key: 346,
    code: '5000002-8420',
    commune: 'TREGUACO',
  },
]
